import { createGlobalState, useGlobalState } from "@givenwell/hooks";
import { createContext } from "react";
import { Command, LaunchProps, RichSearchResult } from "./types";

const commandsState = createGlobalState<Command[]>([]);

export function addCommand(command: Command) {
  commandsState.setValue([...commandsState.getValue(), command]);
  return () => {
    commandsState.setValue(commandsState.getValue().filter(c => c !== command));
  };
}

export function addCommands(commands: Command[]) {
  commandsState.setValue([...commandsState.getValue(), ...commands]);
  return () => {
    commandsState.setValue(commandsState.getValue().filter(c => !commands.includes(c)));
  };
}

export function hasCommands() {
  return commandsState.getValue().length;
}

export function useCommands() {
  return useGlobalState(commandsState);
}

export type StackItem = {
  command: Command;
  launchProps: LaunchProps;
};

type NavigationContextType = {
  stack: StackItem[];
  push: (command: Command, fallbackText?: string) => void;
  pop: () => void;
  popToRoot: () => void;
  close: () => void;
};

export const NavigationContext = createContext({} as NavigationContextType);

const richSearchResultsState = createGlobalState<RichSearchResult[]>([]);

export function addRichSearchResult(result: RichSearchResult) {
  richSearchResultsState.setValue([...richSearchResultsState.getValue(), result]);
  return () => {
    richSearchResultsState.setValue(richSearchResultsState.getValue().filter(c => c !== result));
  };
}

export function addRichSearchResults(results: RichSearchResult[]) {
  richSearchResultsState.setValue([...richSearchResultsState.getValue(), ...results]);
  return () => {
    richSearchResultsState.setValue(richSearchResultsState.getValue().filter(c => !results.includes(c)));
  };
}

export function useRichSearchResults() {
  return useGlobalState(richSearchResultsState);
}
